//3rd Party Components
import React from 'react';
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

//Pages
import { ProfileSelectorPage } from "../../pages/ProfileSelectorPage";
import { ProfileIndPage } from "../../pages/ProfileIndPage";
import { LinkARNPage } from "../../pages/LinkARNPage";
import { POIPage } from "../../pages/POIPage";

//Actions
import { getUserHomePage } from "../../components/Portal/Utilities";

const HomePageRoute = () => {
    let userdetails = useSelector(state => state.userdetails);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftsIndividual.draftARNs);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let loginPath = useSelector(state => state.B2CSettings.items.loginPath);
    const calcHomePage = (rprops) => {

        let homepage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

        switch (homepage) {

            case 'profileselector':
                return <ProfileSelectorPage {...rprops} />;

            case 'dashind':
                return <ProfileIndPage {...rprops} />;

            case 'linkarn':
                return <LinkARNPage {...rprops} />;

            case 'verifypoi':
                return <POIPage {...rprops} />;

            default:
                return null;
        }

    }

    return (
        <Route render={(rprops => {
            return calcHomePage(rprops)
        })}>
        </Route>
    );

};

export default HomePageRoute;

